(function () {
  'use strict';

  const cfg = window.BBH_CONFIG || {};
  const rootUrl = ((cfg.rootUrl || '/').replace(/\/?$/, '/'));
  const qs = (sel, root) => (root || document).querySelector(sel);
  const qsa = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function safeParse(raw, fallback) {
    try { return JSON.parse(raw); } catch (e) { return fallback; }
  }

  function loadSaved(key) {
    const value = safeParse(localStorage.getItem(key) || '[]', []);
    return Array.isArray(value) ? value : [];
  }

  function saveSaved(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function toast(message) {
    let el = qs('.bbh-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-showing');
    clearTimeout(el._bbhTimer);
    el._bbhTimer = setTimeout(() => el.classList.remove('is-showing'), 2600);
  }

  function productDataFromCard(card) {
    return {
      handle: card.dataset.productHandle || '',
      title: card.dataset.productTitle || '',
      vendor: card.dataset.productVendor || '',
      url: card.dataset.productUrl || '#',
      price: card.dataset.productPrice || '',
      available: card.dataset.productAvailable || '',
      image: card.dataset.productImage || ''
    };
  }

  function initHero(storefront) {
    const hero = qs('[data-bbh-hero]', storefront);
    if (!hero) return;
    const slides = qsa('[data-bbh-slide]', hero);
    const dots = qsa('[data-bbh-dot]', hero);
    if (!slides.length) return;
    let current = 0;
    let timer = null;
    const autoplay = hero.dataset.autoplay === 'true';
    const speed = Math.max(2500, parseInt(hero.dataset.speed || '6500', 10));

    function ensureSlideImage(index) {
      const slide = slides[index];
      if (!slide) return;
      const img = qs('img[data-bbh-lazy-src]', slide);
      if (img && !img.getAttribute('src')) {
        img.setAttribute('src', img.dataset.bbhLazySrc);
        img.removeAttribute('data-bbh-lazy-src');
        img.decoding = 'async';
      }
    }
    function show(index) {
      current = (index + slides.length) % slides.length;
      ensureSlideImage(current);
      ensureSlideImage((current + 1) % slides.length);
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(() => show(current + 1), speed);
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); restart(); }));
    const prev = qs('[data-bbh-prev]', hero);
    const next = qs('[data-bbh-next]', hero);
    if (prev) prev.addEventListener('click', () => { show(current - 1); restart(); });
    if (next) next.addEventListener('click', () => { show(current + 1); restart(); });
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', restart);
    show(0);
    restart();
  }

  function initTabs(storefront) {
    qsa('[data-bbh-tabs]', storefront).forEach(tabs => {
      const buttons = qsa('[data-bbh-tab]', tabs);
      const section = tabs.closest('[data-bbh-tab-section]') || storefront;
      const panels = qsa('[data-bbh-panel]', section);
      buttons.forEach(btn => btn.addEventListener('click', () => {
        const target = btn.dataset.bbhTab;
        buttons.forEach(b => b.classList.toggle('is-active', b === btn));
        panels.forEach(p => p.classList.toggle('is-active', p.dataset.bbhPanel === target));
        section.dispatchEvent(new CustomEvent('bbh:tab-change', { bubbles: false }));
      }));
    });
  }


  function initProductCarousels(storefront) {
    qsa('[data-bbh-product-carousel]', storefront).forEach(carousel => {
      if (carousel.dataset.bbhCarouselInitialized === 'true') return;
      const viewport = qs('.bbh-product-carousel-viewport', carousel);
      const track = qs('[data-bbh-product-track]', carousel);
      if (!viewport || !track || !track.children.length) return;

      carousel.dataset.bbhCarouselInitialized = 'true';
      const interval = Math.max(1500, parseInt(carousel.dataset.bbhCarouselInterval || '3000', 10));
      let timer = null;
      let paused = false;

      function cards() { return Array.from(track.children); }
      function gapSize() {
        const styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }
      function stepSize() {
        const first = cards()[0];
        return first ? first.getBoundingClientRect().width + gapSize() : 0;
      }
      function visibleCount() {
        const step = stepSize();
        return step ? Math.max(1, Math.round(viewport.clientWidth / step)) : 1;
      }
      function maxIndex() {
        return Math.max(0, cards().length - visibleCount());
      }
      function currentIndex() {
        const step = stepSize();
        return step ? Math.round(viewport.scrollLeft / step) : 0;
      }
      function go(index, smooth) {
        const max = maxIndex();
        const target = Math.max(0, Math.min(index, max));
        viewport.scrollTo({ left: target * stepSize(), behavior: smooth ? 'smooth' : 'auto' });
      }
      function next() {
        if (carousel.offsetParent === null) return;
        const max = maxIndex();
        if (!max) return;
        const current = currentIndex();
        if (current >= max) go(0, false);
        else go(current + 1, true);
      }
      function prev() {
        const max = maxIndex();
        if (!max) return;
        const current = currentIndex();
        if (current <= 0) go(max, false);
        else go(current - 1, true);
      }
      function stop() {
        clearInterval(timer);
        timer = null;
      }
      function isMobileOnlyInactive() {
        return carousel.hasAttribute('data-bbh-mobile-only-carousel') &&
          !window.matchMedia('(max-width: 767px)').matches;
      }

      function start() {
        stop();
        if (isMobileOnlyInactive()) {
          viewport.scrollTo({ left: 0, behavior: 'auto' });
          return;
        }
        if (paused || document.hidden || cards().length <= visibleCount()) return;
        timer = setInterval(next, interval);
      }

      const prevBtn = qs('[data-bbh-product-prev]', carousel);
      const nextBtn = qs('[data-bbh-product-next]', carousel);
      if (prevBtn) prevBtn.addEventListener('click', () => { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { next(); start(); });

      carousel.addEventListener('mouseenter', () => { paused = true; stop(); });
      carousel.addEventListener('mouseleave', () => { paused = false; start(); });
      carousel.addEventListener('focusin', () => { paused = true; stop(); });
      carousel.addEventListener('focusout', event => {
        if (!carousel.contains(event.relatedTarget)) { paused = false; start(); }
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      storefront.addEventListener('bbh:tab-change', () => {
        requestAnimationFrame(() => { go(0, false); start(); });
      });

      if (carousel.hasAttribute('data-bbh-mobile-only-carousel')) {
        const mobileMedia = window.matchMedia('(max-width: 767px)');
        const handleModeChange = () => {
          stop();
          viewport.scrollTo({ left: 0, behavior: 'auto' });
          if (mobileMedia.matches) start();
        };
        if (typeof mobileMedia.addEventListener === 'function') {
          mobileMedia.addEventListener('change', handleModeChange);
        } else if (typeof mobileMedia.addListener === 'function') {
          mobileMedia.addListener(handleModeChange);
        }
      }

      start();
    });
  }

  async function getCart() {
    const res = await fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Cart could not be loaded');
    return res.json();
  }

  function updateCartUI(storefront, cart) {
    qsa('[data-bbh-cart-count]', storefront).forEach(el => { el.textContent = cart.item_count; });
    if (cfg.moneyFormat && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      qsa('[data-bbh-cart-total]', storefront).forEach(el => { el.textContent = window.Shopify.formatMoney(cart.total_price, cfg.moneyFormat); });
    }
  }

  function initCart(storefront) {
    qsa('[data-bbh-add-form]', storefront).forEach(form => {
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = qs('[data-bbh-add-button]', form);
        const id = Number(qs('input[name="id"]', form).value);
        const quantity = Number((qs('input[name="quantity"]', form) || {}).value || 1);
        if (!id) return;
        const oldText = button ? button.textContent : '';
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }
        let itemAdded = false;
        try {
          const addRes = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }] })
          });
          if (!addRes.ok) {
            const err = await addRes.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add this item');
          }
          itemAdded = true;
          const cart = await getCart();
          updateCartUI(storefront, cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          toast('Added to cart');
        } catch (err) {
          toast(err.message || 'Could not add this item');
          if (!itemAdded) { form.submit(); return; }
        } finally {
          if (button) { button.disabled = false; button.textContent = oldText; }
        }
      });
    });
  }

  function initSavedProducts(storefront) {
    const wishlistKey = 'bbh_wishlist_v1';
    const compareKey = 'bbh_compare_v1';
    let wishlist = loadSaved(wishlistKey);
    let compare = loadSaved(compareKey);
    const wishlistModal = qs('[data-bbh-wishlist-modal]', storefront);
    const compareModal = qs('[data-bbh-compare-modal]', storefront);
    const tray = qs('[data-bbh-compare-tray]', storefront);

    function has(list, handle) { return list.some(item => item.handle === handle); }
    function setCount() {
      qsa('[data-bbh-wishlist-count]', storefront).forEach(el => { el.textContent = wishlist.length; });
      qsa('[data-bbh-compare-count]', storefront).forEach(el => { el.textContent = compare.length; });
    }
    function syncButtons() {
      qsa('[data-bbh-product-card]', storefront).forEach(card => {
        const handle = card.dataset.productHandle;
        const wish = qs('[data-bbh-wishlist]', card);
        const cmp = qs('[data-bbh-compare]', card);
        if (wish) { const active = has(wishlist, handle); wish.classList.toggle('is-active', active); wish.setAttribute('aria-pressed', active ? 'true' : 'false'); }
        if (cmp) { const active = has(compare, handle); cmp.classList.toggle('is-active', active); cmp.setAttribute('aria-pressed', active ? 'true' : 'false'); }
      });
    }
    function renderTray() {
      if (!tray) return;
      tray.classList.toggle('is-open', compare.length > 0);
      const holder = qs('[data-bbh-compare-items]', tray);
      if (!holder) return;
      holder.innerHTML = compare.map(item => `<div class="bbh-compare-pill"><span>${escapeHtml(item.title)}</span><button type="button" data-bbh-remove-compare="${escapeAttr(item.handle)}" aria-label="Remove">×</button></div>`).join('');
    }
    function renderWishlist() {
      if (!wishlistModal) return;
      const holder = qs('[data-bbh-wishlist-items]', wishlistModal);
      if (!holder) return;
      holder.innerHTML = wishlist.length ? wishlist.map(item => `<a class="bbh-saved-item" href="${escapeAttr(item.url)}">${item.image ? `<img src="${escapeAttr(item.image)}" alt="">` : ''}<strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(item.price)}</span></a>`).join('') : '<p>No saved products yet.</p>';
    }
    function renderCompare() {
      if (!compareModal) return;
      const holder = qs('[data-bbh-compare-table]', compareModal);
      if (!holder) return;
      if (!compare.length) { holder.innerHTML = '<p>Select products using the compare icon first.</p>'; return; }
      const row = (label, key, isLink) => `<tr><th>${escapeHtml(label)}</th>${compare.map(item => `<td>${isLink ? `<a href="${escapeAttr(item.url)}">${escapeHtml(item[key])}</a>` : escapeHtml(item[key] || '')}</td>`).join('')}</tr>`;
      holder.innerHTML = `<table class="bbh-compare-table"><tbody>${row('Product','title',true)}${row('Brand','vendor')}${row('Price','price')}${row('Availability','available')}</tbody></table>`;
    }
    function closeModals() { qsa('.bbh-modal.is-open', storefront).forEach(m => m.classList.remove('is-open')); document.documentElement.style.overflow = ''; }
    function openModal(modal) { if (!modal) return; renderWishlist(); renderCompare(); modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }

    storefront.addEventListener('click', event => {
      const wishBtn = event.target.closest('[data-bbh-wishlist]');
      const cmpBtn = event.target.closest('[data-bbh-compare]');
      const card = event.target.closest('[data-bbh-product-card]');
      if (wishBtn && card) {
        const item = productDataFromCard(card);
        wishlist = has(wishlist, item.handle) ? wishlist.filter(x => x.handle !== item.handle) : wishlist.concat(item);
        saveSaved(wishlistKey, wishlist); setCount(); syncButtons(); renderWishlist(); toast(has(wishlist, item.handle) ? 'Saved to wishlist' : 'Removed from wishlist');
      }
      if (cmpBtn && card) {
        const item = productDataFromCard(card);
        if (has(compare, item.handle)) compare = compare.filter(x => x.handle !== item.handle);
        else if (compare.length >= 4) { toast('You can compare up to 4 products'); return; }
        else compare = compare.concat(item);
        saveSaved(compareKey, compare); setCount(); syncButtons(); renderTray(); renderCompare();
      }
      const remove = event.target.closest('[data-bbh-remove-compare]');
      if (remove) {
        compare = compare.filter(x => x.handle !== remove.dataset.bbhRemoveCompare);
        saveSaved(compareKey, compare); setCount(); syncButtons(); renderTray(); renderCompare();
      }
      if (event.target.closest('[data-bbh-clear-compare]')) {
        compare = []; saveSaved(compareKey, compare); setCount(); syncButtons(); renderTray(); renderCompare();
      }
      if (event.target.closest('[data-bbh-open-wishlist]')) openModal(wishlistModal);
      if (event.target.closest('[data-bbh-open-compare]')) openModal(compareModal);
      if (event.target.closest('[data-bbh-modal-close]') || (event.target.classList && event.target.classList.contains('bbh-modal'))) closeModals();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModals(); });
    setCount(); syncButtons(); renderTray();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
  }
  function escapeAttr(value) { return escapeHtml(value); }

  function initCountdown(storefront) {
    qsa('[data-bbh-countdown]', storefront).forEach(el => {
      const endRaw = el.dataset.end;
      if (!endRaw) return;
      const end = new Date(endRaw);
      if (Number.isNaN(end.getTime())) return;
      const days = qs('[data-days]', el), hours = qs('[data-hours]', el), mins = qs('[data-minutes]', el), secs = qs('[data-seconds]', el);
      function tick() {
        let remaining = Math.max(0, end.getTime() - Date.now());
        const d = Math.floor(remaining / 86400000); remaining -= d * 86400000;
        const h = Math.floor(remaining / 3600000); remaining -= h * 3600000;
        const m = Math.floor(remaining / 60000); remaining -= m * 60000;
        const s = Math.floor(remaining / 1000);
        if (days) days.textContent = String(d).padStart(2,'0');
        if (hours) hours.textContent = String(h).padStart(2,'0');
        if (mins) mins.textContent = String(m).padStart(2,'0');
        if (secs) secs.textContent = String(s).padStart(2,'0');
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function formatPredictivePrice(price) {
    const numeric = Number(price);
    if (!Number.isFinite(numeric)) return String(price == null ? '' : price);
    if (cfg.moneyFormat && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Math.round(numeric * 100), cfg.moneyFormat);
    }
    return numeric.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function initPredictiveSearch(storefront) {
    const form = qs('[data-bbh-search]', storefront);
    if (!form || !cfg.predictiveSearchUrl) return;
    const input = qs('input[name="q"]', form);
    const results = qs('[data-bbh-search-results]', form);
    if (!input || !results) return;
    let timer = null;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.classList.remove('is-open'); results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = cfg.predictiveSearchUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { headers:{ 'Accept':'application/json' } });
          if (!res.ok) return;
          const data = await res.json();
          const products = (((data || {}).resources || {}).results || {}).products || [];
          results.innerHTML = products.length ? products.map(p => `<a class="bbh-search-result" href="${escapeAttr(p.url)}">${p.image ? `<img src="${escapeAttr(p.image)}" alt="">` : '<span></span>'}<div><strong>${escapeHtml(p.title)}</strong><span>${escapeHtml(formatPredictivePrice(p.price))}</span></div></a>`).join('') : '<div style="padding:14px">No products found.</div>';
          results.classList.add('is-open');
        } catch (e) {}
      }, 220);
    });
    document.addEventListener('click', event => { if (!form.contains(event.target)) results.classList.remove('is-open'); });
  }





  function initHeader(storefront) {
    const header = qs('[data-bbh-reference-header]', storefront);
    if (!header) return;

    const menu = qs('[data-bbh-menu-toggle]', header);
    if (menu) menu.addEventListener('click', () => header.classList.toggle('is-menu-open'));

    const categoriesMenu = qs('[data-bbh-categories-menu]', header);
    const categoriesToggle = qs('[data-bbh-categories-toggle]', header);

    function setCategories(open) {
      if (!categoriesMenu || !categoriesToggle) return;
      categoriesMenu.classList.toggle('is-open', open);
      categoriesToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (categoriesMenu && categoriesToggle) {
      categoriesToggle.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        setCategories(!categoriesMenu.classList.contains('is-open'));
      });

      categoriesMenu.addEventListener('click', event => {
        if (event.target.closest('.bbh-categories-dropdown a')) setCategories(false);
      });

      document.addEventListener('click', event => {
        if (!categoriesMenu.contains(event.target)) setCategories(false);
      });

      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') setCategories(false);
      });
    }
  }

  function initStorefront(storefront) {
    if (storefront.dataset.bbhInitialized === 'true') return;
    storefront.dataset.bbhInitialized = 'true';
    initHero(storefront);
    initTabs(storefront);
    initProductCarousels(storefront);
    initCart(storefront);
    initSavedProducts(storefront);
    initCountdown(storefront);
    initPredictiveSearch(storefront);
    initHeader(storefront);
  }

  function initAll() { qsa('[data-bbh-storefront]').forEach(initStorefront); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
